<template>
  <section id="page" class="section">
    <Header :class="{header: true, hidden: hideHeader}"
      v-on:login="$emit('login')" :scrolled="true"/>
    <div :class="{tabMenu: true, hidden: hideHeader}">
      <div class="tabMenuWrapper" v-if="detail && detail.parent">
        <router-link to="/" class="tabMenuItem z">Home</router-link>
        <div class="tabMenuItem x">/</div>
        <div v-on:click="$router.back()" class="tabMenuItem z">
          {{detail.parent.name}}</div>
        <div class="tabMenuItem x">/</div>
        <div class="tabMenuItem y">{{detail.title}}</div>
      </div>
    </div>

    <div class="content contentLoading" v-if="!detail"></div>
    <div v-else>
      <div class="articleDetail">
        <div class="content">
          <h2 class="articleTitle">{{detail.title}}</h2>
          <div class="authorInfo" v-if="detail.parent.slug !== 'static-pages'">
            <div class="authorImg"></div>
            <h4>{{detail.author.name}}</h4>
            <div class="publishTime">
              <span class="timestamp">
                {{detail.publishDate | moment('ddd, D MMM YYYY hh:mm')}}
              </span>
              <!-- <span class="bull">&bull;</span> -->
              <div class="reading-time">
                <span class="reading-time__label"></span>
                <span class="reading-time__duration"></span>
                <span class="reading-time__word-count"></span>
              </div>
            </div>
          </div>
          <div class="articleShare articleShareStatic">
            <h4>Share</h4>
            <div class="shareCnt">
              <a target="_balnk"
                :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
                <i class="fa fa-facebook fa-fw"></i>
              </a>
              <a target="_balnk"
                :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
                <i class="fa fa-twitter fa-fw"></i>
              </a>
              <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
                <i class="fa fa-whatsapp fa-fw"></i>
              </a>
              <a target="_balnk"
                :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
                <i class="fa fa-telegram fa-fw"></i>
              </a>
              <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
                <a href='${shareUri}'>${detail.title}</a>`">
                <i class="fa fa-email fa-fw"></i>
              </a>
            </div>
          </div>
          <div class="articleContent detail-wrapper" v-html="detail.content"/>
        </div>

        <div class="articleShare" :style="{top: `${shareTop}px`}">
          <h4>Share</h4>
          <div class="shareCnt">
            <a target="_balnk"
              :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
              <i class="fa fa-facebook fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
              <i class="fa fa-twitter fa-fw"></i>
            </a>
            <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
              <i class="fa fa-whatsapp fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
              <i class="fa fa-telegram fa-fw"></i>
            </a>
            <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
              <a href='${shareUri}'>${detail.title}</a>`">
              <i class="fa fa-email fa-fw"></i>
            </a>
          </div>
        </div>

        <div ref="endArticle"/>
        <div class="relatedWrapper" v-if="related && related.length > 0">
          <h4 class="relatedTitle">Artikel Terkait</h4>
          <div class="relatedSc">
            <div class="relatedCnt">
              <div class="relatedItem" v-for="(item, index) in related" :key="index">
                <a :href="`/${item.parent.slug}/read/${item.slug}`">
                  <div class="relatedImg" :style="{'background-image': `url(${item.thumb})`}"/>
                </a>
                <a :href="`/${item.parent.slug}/read/${item.slug}`">
                  <h4>{{item.title}}</h4>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'read',
  components: {
    Header,
  },
  data() {
    return {
      detail: null,
      related: [],
      hideHeader: false,
      shareTop: 360,
    };
  },
  methods: {
    onScrolled() {
      const currentScrollPos = window.pageYOffset;
      const aHRect = this.$refs.endArticle.getBoundingClientRect();
      if (aHRect.top > 610) {
        this.shareTop = 360 + currentScrollPos;
      }
      if (currentScrollPos > 100) {
        if (this.prevScrollpos > currentScrollPos) {
          this.hideHeader = false;
        } else {
          this.hideHeader = true;
        }
      } else {
        this.hideHeader = false;
      }
      this.prevScrollpos = currentScrollPos;
    },
  },
  computed: {
    shareUri() {
      return `https://demo.bumibutuhaksi.id/${this.detail.parent.slug}/read/${this.detail.slug}`;
    },
  },
  created() {
    window.addEventListener('scroll', this.onScrolled);
    this.prevScrollpos = window.pageYOffset;
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolled);
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$http.get(this.$config.uri(`article/${this.$route.params.slug}`)).then((response) => {
      this.detail = (response.data.status === 200) ? response.data.data : null;
      if (this.detail) {
        document.title = `${this.detail.title} - Bumi Butuh Aksi`;
        this.$http.get(this.$config.uri(`article/all?parent=${this.detail.parent.slug}
          &related=${this.detail.id}&limit=3`))
          .then((response2) => {
            this.related = (response2.data.status === 200) ? response2.data.data : null;
          });
      }
    });
    setTimeout(() => {
      ReadingTime(270, 'Reading time:', 'min', 'words', 'Less than a minute');
    });
  },
};
</script>

<style scoped lang="scss">
.relatedWrapper{
  max-width: 750px;
  margin: 0 auto;
}
.section{
  margin: 0 auto;
}
.tabMenu{
  position: fixed;
  top: 80px;
  left: 0;
  background-color: #f5f5f5;
  right: 0;
  border-bottom: #eee 1px solid;
  transition: all .3s ease;
  z-index: 9;
  @media (max-width: 760px) {
    top: 63px;
  }
  &.hidden{
    top: 0;
  }
  .tabMenuWrapper{
    display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 0 10px;
    .tabMenuItem{
      padding: 10px 20px 8px;
      color: #444;
      cursor: pointer;
      font-weight: 600;
      border-bottom: transparent 3px solid;
      margin-bottom: -1px;
      text-decoration: none;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      @media (max-width: 760px) {
        padding-left: 10px;
        padding-right: 10px;
      }
      &.z{
        color: #084630;
        &:hover{
          color: #31c1f4;
        }
      }
      &.x{
        padding-left: 0;
        padding-right: 0;
        color: #aaa;
      }
      &.y{
        color: #767676;
        font-weight: normal;
        @media (max-width: 760px) {
          max-width: 160px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
  .relatedTitle{
    width: 100%;
    margin: 0;
    margin-bottom: 14px;
    font-size: 20px;
    padding-top: 40px;
  }
  .relatedCnt{
    display: flex;
    margin-right: -20px;
    flex-wrap: wrap;
    .relatedItem{
      width: calc(33.3333% - 20px);
      margin-right: auto;
      .relatedImg{
        height: 236px;
        background-size: cover;
        background-position: center;
        background-color: #eee;
        margin-bottom: 10px;
        transition: all .2s ease;
        &:hover{
          transform: scale(1.02);
          box-shadow: 4px 4px 0 #31c1f4;
        }
      }
      a{
        text-decoration: none;
        color: #444;
        &:hover{
          color: #31c1f4;
        }
      }
      h4{
        margin: 0;
        padding-left: 7px;
      }
    }
  }
  @media (max-width: 760px){
    .relatedSc{
      margin: 0 -20px;
      overflow-x: auto;
      .relatedCnt{
        width: 780px;
        padding-left: 20px;
        padding-bottom: 10px;
        .relatedItem{
          margin: 0;
          width: 240px;
          margin-right: 20px;
          .relatedImg{
            height: 240px;
            border-radius: 10px;
          }
        }
      }
    }
  }

  .articleDetail{
    padding: 140px 0 40px;
    min-height: calc(100vh - 182px);
    .content{
      max-width: 750px;
      margin: 0 auto;
      .articleTitle{
        font-size: 40px;
        margin: 0;
        font-weight: bold;
        line-height: 1.3;
        margin-bottom: 20px;
      }
      .articleContent{
        font-size: 20px;
        line-height: 1.6;
        blockquote{
          font-size: 26px;
          line-height: 1.3;
          border-left: #ddd 4px solid;
          position: relative;
          margin: 26px 0;
          padding-bottom: 6px;
          color: #767676;
          padding-left: 50px;
          padding-left: 30px;
          &:before{
            content: "\"";
            font-size: 80px;
            position: absolute;
            left: 14px; top: -14px;
            display: none;
          }
        }
        p.caption{
          margin: -14px 0 20px 10px;
          font-size: 15px;
          line-height: 1.4;
          min-height: 22px;
        }

        p{
          margin: 0;
        }
        iframe.theMedia{
          border: none;
        }
        iframe.theMedia:not(.theEmbed){
          height: 420px;
          @media (max-width: 700px){
            height: 200px;
          }
        }
        .theMedia{
          display: block;
          margin: 20px 0;
          width: 100%;
          border-radius: 5px;
          position: relative;
          z-index: 3;
          &.md-wide{
            width: calc(100% + 200px);
            margin: 20px -100px;
            @media (max-width: 974px) {
              width: calc(100% + 100px);
              margin: 20px -50px;
            }
            @media (max-width: 874px) {
              width: calc(100% + 40px);
              margin: 20px -20px;
              border-radius: 0;
            }
          }
        }
      }
    }
    @media (max-width: 700px) {
      padding: 130px 0 30px;
      .content{
        .articleTitle{
          font-size: 30px;
          line-height: 1.3;
          margin-bottom: 10px;
        }
        .articleContent{
          font-size: 18px;
          line-height: 1.6;
        }
      }
    }
  }

  .authorInfo{
    position: relative;
    padding-top: 8px;
    // padding-left: 50px;
    padding-bottom: 30px;
    @media (max-width: 700px) {
      padding-bottom: 16px;
    }
    .authorImg{
      position: absolute;
      left: 0;
      top: 8px;
      width: 39px;
      height: 39px;
      background-color: #ccc;
      background-image: url(../assets/user.png);
      background-size: cover;
      border-radius: 50%;
      cursor: pointer;
      display: none;
    }
    h4{
      margin: 0;
      font-size: 17px;
    }
    .publishTime{
      margin: 0;
      font-size: 14px;
    }
  }

  .articleShare{
    position: absolute;
    top: 360px;
    left: calc(((100% - 750px) / 2) - 80px);
    padding: 0 10px 5px;
    background-color: #fff;
    border-radius: 5px;
    &.articleShareStatic{
      padding-top: 0;
      padding-bottom: 20px;
      @media (min-width: 976px) {
        display: none;
      }
    }
    h4{
      margin: 0 0 10px;
      font-size: 12px;
      text-align: center;
      text-transform: uppercase;
      color: #767676;
    }
    a{
      display: block;
      .fa{
        width: 40px;
        height: 40px;
        display: block;
        border-radius: 50%;
        margin: 0 auto;
        margin-top: 4px;
        background-size: 26px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .5;
        &:hover{
          background-color: #fff;
          opacity: 1;
        }
      }
      .fa.fa-facebook{
        background-image: url(../assets/share-facebook.png);
      }
      .fa.fa-twitter{
        background-image: url(../assets/share-twitter.png);
      }
      .fa.fa-whatsapp{
        background-image: url(../assets/share-whatsapp.png);
      }
      .fa.fa-telegram{
        background-image: url(../assets/share-telegram.png);
      }
      .fa.fa-email{
        background-image: url(../assets/share-email.png);
      }
    }
    @media (max-width: 974px) {
      position: static;
      display: flex;
      left: 0;
      top: auto;
      transform: none;
      bottom: 70px;
      border-radius: 0;
      flex-wrap: wrap;
      padding: 20px 0 0;
      h4{
        width: 50px;
        padding-top: 6px;
        width: 100%;
        text-align: left;
        margin-bottom: 6px;
        font-size: 17px;
        text-transform: none;
      }
      .shareCnt{
        display: flex;
        margin-left: -5px;
        a{
          margin: 0;
          margin-right: 10px;
          padding: 0;
          .fa{
            margin: 0;
          }
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  .contentLoading{
    padding-top: 60px;
  }
</style>
